import { Injectable, Injector, Type } from '@angular/core';

import { ModalRef } from '@app/modules/core-modal/models/modal-ref';
import { CoreModalService } from '@app/modules/core-modal/services/core-modal.service';
import { ModalParams } from '@app/modules/core-modal/types/modal.types';
import { ModalComponent } from '@app/modules/modal-components-common/modal.component';

@Injectable()
export abstract class ModalService {
  public constructor(
    protected injector: Injector,
    protected coreModalService: CoreModalService,
  ) {}

  public open<T>(
    component: Type<ModalComponent>,
    params?: ModalParams,
  ): ModalRef<T> {
    return this.coreModalService.createComponent(
      component,
      this.injector,
      params,
    );
  }

  public openChildModal<T>(
    component: Type<ModalComponent>,
    params?: ModalParams,
  ): ModalRef<T> {
    return this.coreModalService.createComponent(
      component,
      this.injector,
      params,
      true,
    );
  }
}
